import Utils from 'common/scripts/utils';

class Panel {
    constructor() {
        // close, header, content
        this.state = 'close';
        this.defDelay = 300;
        this.id = null;
    }

    /**
     * Открывает панель при клике на маркер.
     * @param {object} target - геообъект по которому произошло событие.
     */
    open(target) {
        this.data = target.options.get('data');
        this.template = target.options.get('template');
        // eslint-disable-next-line
        this.domTarget = target.getOverlaySync().getLayoutSync().getElement();
        this.marker = this.domTarget.querySelector('.j-yandex-map-marker');
        this.wrapper = this.marker.closest('.j-yandex-map-base');

        if (this.id === Number(this.data.id)) {
            // Если клик произошел потому же маркеру, то надо просто закрыть панельку.
            this._close();
        } else if (this.id !== Number(this.data.id) && this.state !== 'close') {
            // Если клик произошел по новому маркеру, но при этом панелька уже открыта, то нужно закрыть и открыть
            // новую с задержкой
            this._close();
            this._createTemplate('repeat');
        } else {
            this._createTemplate();
        }

        this._bindMapClickListener();
    }

    _bindMapClickListener() {
        window.addEventListener('bindMapClick', () => {
            this._close();
        });
    }

    /**
     * Создает шаблон панели.
     * @param {string} repeat - если клик произошел при уже открытой панельки, то это параметр показывает,
     * что нужно показать панельку с задержкой
     * @private
     */
    _createTemplate(repeat = '') {
        const noDelay = 0;
        const delay = repeat ? this.defDelay : noDelay;

        this._setStateMarker();

        setTimeout(() => {
            Utils.insetContent(this.wrapper, this.template(this.data));

            this.id = Number(this.data.id);

            this._getElements();
            this._bindEvents();
            this._showPanel();
        }, delay);
    }

    /**
     * Метод получает элементы панельки
     * @private
     */
    _getElements() {
        this.panel = this.wrapper.querySelector('.j-yandex-map-baloon');
        this.panelHeight = this.panel.offsetHeight;
    }

    /**
     * Мето навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        // const close = this.panel.querySelector('.j-yandex-map-close-baloon');
        //
        // close.addEventListener('click', () => {
        //     this._close();
        // });
    }

    /**
     * Метод показывает только заголовок.
     * @private
     */
    _showPanel() {
        this.panel.style.transform = `translateY(${-this.panelHeight}px)`;
        this.state = 'show';
        this.wrapper.classList.add('is-active');
    }

    /**
     * Метод скрывает всю панельку.
     * @private
     */
    _hideAll() {
        const start = 0;

        this.panel.style.transform = `translateY(${start}px)`;
        this.state = 'close';
        this.wrapper.classList.remove('is-active');
    }

    /**
     * Метод удаляет панельку со страницы.
     * @private
     */
    _close() {
        this._removeStateMarker();
        this._hideAll();
        this.id = 'тест';

        setTimeout(() => {
            Utils.removeElement(this.panel);
        }, this.defDelay);
    }

    /**
     * Устанавливает активное состояние для маркера при клике на нем.
     * @private
     */
    _setStateMarker() {
        if (this.marker) {
            this.marker.classList.add('is-active');
        }
    }

    /**
     * Метод удаляет активное состояние у маркера.
     * @private
     */
    _removeStateMarker() {
        if (!this.marker) {
            return;
        }
        // Удаляем класс через querySelector, т.к при клике на другой маркер при активном текущем удаляется текущий,
        // а не предыдущий
        this.activeMarker = this.wrapper.querySelector('.j-yandex-map-marker.is-active');

        if (this.activeMarker) {
            this.activeMarker.classList.remove('is-active');
        }

        this.marker.classList.remove('is-active');
    }
}

export default Panel;
